<template>
  <div>
    <v-btn @click="authGoogle" color="primary" ><v-icon>mdi-google</v-icon> Connect Google</v-btn>
  </div>
</template>
<script>
  import Vue from 'vue'
  import GAuth from 'vue-google-oauth2'
  export default {
    name:"facebookLogin",
    props: {
      app: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      appSecret: {
        type: String,
        default: ()=>{
          return ''
        }
      },
    },
    async mounted() {

    },
    methods: {
      async authGoogle(){
        const gauthOption = {
          clientId: this.app.client_id,
          scope: 'https://www.googleapis.com/auth/business.manage',
          prompt: 'consent'
        }
        await Vue.use(GAuth, gauthOption)
         setTimeout(async ()=>{
           this.app.code = await this.$gAuth.getAuthCode()
           if (this.app._id) {
             delete this.app._id
           }
           this.$http_session_manager.put(`/bots/${this.$store.state.bot.botId}/apps/google-reviews`,this.app)
           .then(response=>{
              this.sendEscalationOption()
           })
           .catch()
        },1500)
      },
      sendEscalationOption () {
        this.$http_session_manager.put(`/bots/apps/google-reviews/${this.app.subscription_name}/escalation-options`,{
          immediately_escalate: this.app.immediately_escalate,
          escalation_queue_name: this.app.escalation_queue_name
        })
        .then()
        .catch()
      }

    },
    watch: {
      appId (){
        if (this.appId) {

        }
      }
    }
  };
</script>
<style>
  .button{
    color:white;
    min-width: 150px;
    background-color: #000000a1;
    height: 2.5rem;
    border-radius: 2rem;
    font-weight: 400;
    font-size: 0.8rem;
  }
</style>
